import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';

import Spinner from '../../spinner/spinner';
import { updateRevival } from "./mutations/updateRevival";
import { deleteRevival } from "./mutations/deleteRevival";
import { Form, Button, Row, Col, Modal } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';
import RevivalForm from "./revivalForm";

const REVIVAL_PREPARATION_PHASE = 1;
const REVIVAL_PHASE = 2;
const REVIVAL_FINISH_PHASE = 3;

class RevivalEditPage extends Component {
  get church() {
    return this.props.selectedChurch;
  }

  get revival() {
    return this.props.selectedChurch.revival;
  }

  get updateMutationParams() {
    const {getFieldValue} = this.props.form;

    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          preparation_start_date: _.inRange(this.church.revival.phase, REVIVAL_PREPARATION_PHASE, REVIVAL_PHASE) ? undefined : getFieldValue('preparation_start_date').unix(),
          start_date: _.inRange(this.church.revival.phase, REVIVAL_PREPARATION_PHASE, REVIVAL_PHASE) ? undefined : getFieldValue('start_date').unix(),
          end_date: this.church.revival.phase == REVIVAL_PHASE ? undefined : getFieldValue('end_date').unix(),
          church_id: parseInt(this.church.id, 10)
        }
      }
    };
  }

  get deleteRevivalParams() {
    return {
      variables: {
        input: {
          church_id: this.church.id
        }
      }
    }
  }

  get validationKeys() {
    return [ 'title', 'preparation_start_date', 'start_date', 'end_date' ];
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      await this.props.updateRevival(this.updateMutationParams);
      this.props.history.push(`/dashboard/${this.church.id}/stats/church/daily`);
    } catch(response) {
      displayServerErrors(this.props.form, response, this.validationKeys);
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        this.submitData();
      }
    });
  };

  onDelete = () => {
    Modal.confirm({
      title: `Are you sure you want to delete event?`,
      okText: "Delete",
      width: 600,
      onOk: () => this.deleteSubmit()
    });
  }

  async deleteSubmit() {
    try {
      this.setState({ loading: true });
      await this.props.deleteRevival(this.deleteRevivalParams);
      window.location.reload();
    } catch(response) {
      Modal.error({
        title: 'Error',
        content: (
          <div>
            Something went wrong
            <br />
            <br />
            Please try again later
          </div>
        ),
        width: 510
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      return (
        <div className="m-24">
          <h2 className="dashboard-section-title">
            Event &nbsp;
            {this.revival.phase < 3 && <Button type="danger" onClick={this.onDelete}>Delete</Button>}
          </h2>
          <div>
            <RevivalForm {...this.props} form={this.props.form}
                        church={this.church}
                        revival={this.revival}
                        onSubmit={this.onSubmit}/>
          </div>
        </div>
      );
    }
  }
}

export default Form.create()(
  compose(
    graphql(updateRevival, { name: "updateRevival" }),
    graphql(deleteRevival, { name: "deleteRevival" }),
  )(RevivalEditPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/revivals/revivalEdit.js